
class ShippingSource {
    constructor(API) {
        this.API = API;
    }

     async selected() {
         return await this.API.get('/index.php?route=api/shipping/selected')
     }
    async setShipping(data) {
        return await this.API.post("/index.php?route=api/shipping/method", data)
    }
    async checkAddress(data) {
        return await this.API.post("/index.php?route=api/shipping/checkAddress", data)
    }
    async pointInPolygon(data) {
        return await this.API.get("/index.php?route=api/geo/pointInPolygon", {
            params: data
        })
    }


    async changeHouse(data) {
        return await this.API.post("/index.php?route=api/shipping/changeHouse", data)
    }
    async geolocate(data) {
        return await this.API.get("/index.php?route=api/geo/reverse/coordinate", {
            params: data
        })
    }
     async pickupList(data = {}) {
         return await this.API.get('/index.php?route=api/location/suggest/pickups', {
             params: data
         })
     }
    async polygonsList(data = {}) {
        return await this.API.get('/index.php?route=api/location/polygons', {
            params: data
        })
    }
}


export default ShippingSource
